"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testField = testField;
exports.default = void 0;

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _PromiseRenderer = babelHelpers.interopRequireDefault(require("PromiseRenderer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

var GooglePlacesAutocompleteField = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(GooglePlacesAutocompleteField, _Component);

  function GooglePlacesAutocompleteField() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, GooglePlacesAutocompleteField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(GooglePlacesAutocompleteField)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "onChange", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "initialValue", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "initialPlace", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "dark", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "placeholder", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "placeFilter", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "disabled", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      value: _this.initialPlace ? _this.initialPlace.result.formatted_address : _this.initialValue,
      results: {},
      places: {},
      currentResult: null,
      currentPlace: _this.initialPlace,
      currentState: 'closed',
      targetState: 'closed',
      selectedIndex: -1,
      showPlaceName: true
    };
    _this._timeout = null;
    return _this;
  }

  babelHelpers.createClass(GooglePlacesAutocompleteField, [{
    key: "inputChanged",
    value: function inputChanged(event) {
      this.setState({
        value: event.target.value
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.targetState == 'open') {
        if (this.state.currentState == 'closed') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'opening'
            });
          }, 0);
        }

        if (this.state.currentState == 'opening') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'open'
            });
          }, 300);
        }

        if (this.state.currentState == 'closing') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'opening'
            });
          }, 0);
        }
      } else if (this.state.targetState == 'closed') {
        if (this.state.currentState == 'open') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'closing'
            });
          }, 0);
        }

        if (this.state.currentState == 'closing') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'closed'
            });
          }, 300);
        }

        if (this.state.currentState == 'opening') {
          clearTimeout(this._timeout);
          this._timeout = setTimeout(function () {
            return _this2.setState({
              currentState: 'closing'
            });
          }, 0);
        }
      }

      if (prevProps.initialPlace != this.props.initialPlace) {
        this.setState({
          value: this.props.initialPlace ? this.props.initialPlace.result.formatted_address : this.props.initialValue,
          currentPlace: this.props.initialPlace
        });
        return;
      } else if (prevProps.initialValue != this.props.initialValue) {
        this.setState({
          value: this.props.initialValue,
          currentPlace: null
        });
        return;
      }

      if (this.state.value) {
        if (this.state.results[this.state.value] && this.state.currentResult != this.state.results[this.state.value]) {
          this.setState(function (state) {
            var apiReq = _this2.state.results[_this2.state.value];
            var prevReq = state.currentRequest;
            var thePlace = state.currentPlace || _this2.props.initialPlace;
            var prevSel = state.selectedIndex;

            if (thePlace || prevSel != -1) {
              Promise.all([prevReq, apiReq]).then(function (_ref) {
                var _ref2 = babelHelpers.slicedToArray(_ref, 2),
                    previousResult = _ref2[0],
                    currentResult = _ref2[1];

                var pos;
                var placeId;

                if (prevSel != -1 && previousResult) {
                  var t = previousResult.predictions[prevSel];
                  if (t) placeId = t.place_id;
                }

                if (!placeId) {
                  if (thePlace) placeId = thePlace.result.place_id;
                }

                pos = -1;

                if (placeId) {
                  for (var i = 0; i < currentResult.predictions.length; i++) {
                    if (currentResult.predictions[i].place_id == thePlace.result.place_id) {
                      pos = i;
                      break;
                    }
                  }
                }

                _this2.setState({
                  selectedIndex: pos
                });
              });
            }

            return {
              selectedIndex: -1,
              currentResult: apiReq
            };
          });
        } else if (!this.state.results[this.state.value]) {
          this.setState(function (state) {
            var extra = '';
            if (_this2.placeFilter) extra += "&types=".concat(encodeURIComponent(_this2.placeFilter));
            var apiReq = (0, _fetch.default)("/resources/clients/place.php?input=".concat(encodeURIComponent(state.value)).concat(extra)).then(function (result) {
              return result.json();
            });
            var prevReq = state.currentRequest;
            var thePlace = state.currentPlace || _this2.props.initialPlace;
            var prevSel = state.selectedIndex;

            if (thePlace || prevSel != -1) {
              Promise.all([prevReq, apiReq]).then(function (_ref3) {
                var _ref4 = babelHelpers.slicedToArray(_ref3, 2),
                    previousResult = _ref4[0],
                    currentResult = _ref4[1];

                var pos;
                var placeId;

                if (prevSel != -1 && previousResult) {
                  var t = previousResult.predictions[prevSel];
                  if (t) placeId = t.place_id;
                }

                if (!placeId) {
                  if (thePlace) placeId = thePlace.result.place_id;
                }

                pos = -1;

                if (placeId) {
                  for (var i = 0; i < currentResult.predictions.length; i++) {
                    if (currentResult.predictions[i].place_id == thePlace.result.place_id) {
                      pos = i;
                      break;
                    }
                  }
                }

                _this2.setState({
                  selectedIndex: pos
                });
              });
            }

            return {
              results: Object.assign({}, state.results, babelHelpers.defineProperty({}, state.value, apiReq)),
              selectedIndex: -1,
              currentResult: apiReq
            };
          });
        }
      }
    }
  }, {
    key: "prediction_format_main",
    value: function prediction_format_main(pred) {
      var t = pred.main_text.split("").map(function (value) {
        return {
          matched: false,
          value: value
        };
      });
      pred.main_text_matched_substrings.forEach(function (v) {
        for (var i = 0; i < v.length; i++) {
          t[v.offset + i].matched = true;
        }
      });
      var b = [];
      t.forEach(function (_ref5) {
        var matched = _ref5.matched,
            value = _ref5.value;
        if (!b.length || b[b.length - 1].matched != matched) b.push({
          matched: matched,
          value: value
        });else b[b.length - 1].value += value;
      });
      return _react.default.createElement("div", {
        className: "gm-main-text"
      }, b.map(function (item, index) {
        return _react.default.createElement("span", {
          key: index,
          className: item.matched ? 'match' : 'no-match'
        }, item.value);
      }));
    }
  }, {
    key: "gotFocus",
    value: function gotFocus() {
      var _this3 = this;

      this.setState({
        targetState: 'open'
      }, function () {
        document.body.removeEventListener('click', _this3.bodyClicked);
        document.body.addEventListener('click', _this3.bodyClicked);
      });
    }
  }, {
    key: "gotRoot",
    value: function gotRoot(node) {
      this.rootNode = node;
    }
  }, {
    key: "bodyClicked",
    value: function bodyClicked(event) {
      var _this4 = this;

      if (this.rootNode.contains(event.target)) return;
      this.setState({
        targetState: 'closed'
      }, function () {
        document.body.removeEventListener('click', _this4.bodyClicked);
      });
    }
  }, {
    key: "gotInput",
    value: function gotInput(node) {
      if (node != this.inputNode) {
        this.inputNode = node;

        if (node) {
          node.setAttribute("autocomplete", "go-away-chrome");
          node.focus();
        }
      }
    }
  }, {
    key: "_renderError",
    value: function _renderError(error) {
      return _react.default.createElement("div", {
        className: "gm-dropdown",
        "data-state": "error"
      }, _react.default.createElement("div", {
        className: "alert alert-danger"
      }, _react.default.createElement("p", null, "Sorry, we can't look up your location right now. Please try again later.")));
    }
  }, {
    key: "_renderPending",
    value: function _renderPending() {
      return _react.default.createElement("div", {
        className: "gm-dropdown",
        "data-state": "loading"
      });
    }
  }, {
    key: "_renderSuccess",
    value: function _renderSuccess(value) {
      var _this5 = this;

      return _react.default.createElement("div", {
        className: "gm-dropdown",
        "data-state": "success"
      }, value.predictions.map(function (prediction, index) {
        return _react.default.createElement("div", {
          className: "gm-prediction ".concat(index == _this5.state.selectedIndex ? 'gm-prediction-selected' : ''),
          key: prediction.id,
          onClick: _this5.selectPrediction,
          "data-prediction": prediction.id
        }, _this5.prediction_format_main(prediction.structured_formatting), _react.default.createElement("div", {
          className: "gm-secondary-text"
        }, prediction.structured_formatting.secondary_text));
      }));
    }
  }, {
    key: "dumpEvent",
    value: function dumpEvent(event) {
      event.persist();
      console.log(event);
    }
  }, {
    key: "gmPlaceName",
    value: function gmPlaceName(node) {
      this.placeName = node;
      this.toggleShowName();
    }
  }, {
    key: "gmPlaceAdr",
    value: function gmPlaceAdr(node) {
      this.placeAdr = node;
      this.toggleShowName();
    }
  }, {
    key: "keyDownEvent",
    value: function keyDownEvent(event) {
      var _this6 = this;

      if (event.key == 'ArrowDown' || event.key == 'ArrowUp') {
        var p = this.state.currentResult;
        var which = event.key;
        p.then(function (value) {
          if (_this6.state.currentResult == p) {
            _this6.setState(function (_ref6) {
              var selectedIndex = _ref6.selectedIndex;

              if (selectedIndex == -1) {
                selectedIndex = which == 'ArrowDown' ? 0 : value.predictions.length - 1;
              } else {
                if (which == 'ArrowUp') {
                  selectedIndex--;
                  if (selectedIndex < 0) selectedIndex = value.predictions.length - 1;
                } else {
                  selectedIndex++;
                  if (selectedIndex >= value.predictions.length) selectedIndex = 0;
                }
              }

              return {
                selectedIndex: selectedIndex
              };
            });
          }
        });
      } else if (event.key == 'Tab') {
        // You're leaving the field by keyboard.
        if (this.state.selectedIndex != -1) {
          this.state.currentResult.then(function (value) {
            var pid = value.predictions[_this6.state.selectedIndex].id;

            _this6.selectPredictionId(pid);
          });
        }

        this.setState({
          targetState: 'closed'
        }, function () {
          document.body.removeEventListener('click', _this6.bodyClicked);
        });
      } else if (event.key == 'Enter') {
        event.preventDefault();
        this.state.currentResult.then(function (value) {
          var pid = value.predictions[_this6.state.selectedIndex].id;

          _this6.selectPredictionId(pid);
        });
      }
    }
  }, {
    key: "toggleShowName",
    value: function toggleShowName() {
      if (!this.placeName || !this.placeAdr) {
        this.setState({
          showPlaceName: true
        });
      } else {
        var items = this.placeAdr.querySelectorAll('span');

        for (var i = 0; i < items.length; i++) {
          if (items[i].textContent == this.state.currentPlace.result.name) {
            _classList.default.add(items[i], 'gm-current-place-name');

            this.placeAdr.dataset.hasPlace = 'true';
            this.setState({
              showPlaceName: false
            });
            return;
          }
        }

        this.setState({
          showPlaceName: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "gm-autocomplete-drop ".concat(this.state.currentState, " ").concat(this.dark ? 'dark' : ''),
        ref: this.gotRoot
      }, this.state.currentState == 'closed' ? this.state.currentPlace ? _react.default.createElement("div", {
        className: "gm-place",
        tabIndex: 0,
        onFocus: this.gotFocus,
        onClick: this.gotFocus
      }, _react.default.createElement("div", {
        className: "gm-place-name",
        style: this.state.showPlaceName ? {} : {
          display: 'none'
        },
        ref: this.gmPlaceName
      }, this.state.currentPlace.result.name), _react.default.createElement("div", {
        className: "gm-place-adr",
        ref: this.gmPlaceAdr,
        dangerouslySetInnerHTML: {
          __html: this.state.currentPlace.result.adr_address
        }
      })) : _react.default.createElement("div", {
        className: "gm-place",
        tabIndex: 0,
        onFocus: this.gotFocus,
        onClick: this.gotFocus
      }, _react.default.createElement("div", {
        className: "gm-place-name",
        "data-is-placeholder": !this.state.value ? 'true' : 'false'
      }, this.state.value || this.props.placeholder)) : _react.default.createElement("input", {
        type: "text",
        value: this.state.value,
        placeholder: this.props.placeholder,
        className: "form-control",
        onKeyDown: this.keyDownEvent,
        onChange: this.inputChanged,
        ref: this.gotInput
      }), (this.state.targetState != 'closed' || this.state.currentState != 'closed') && _react.default.createElement("div", {
        className: "gm-autocomplete-drop-box",
        "data-state": this.state.currentState
      }, _react.default.createElement(_PromiseRenderer.default, {
        promise: this.state.currentResult,
        error: this._renderError,
        success: this._renderSuccess,
        pending: this._renderPending
      }), _react.default.createElement("div", {
        className: "powered-by-google white"
      })));
    }
  }, {
    key: "selectPredictionId",
    value: function selectPredictionId(tgt) {
      var _this7 = this;

      this.state.currentResult.then(function (value) {
        var theValue = value.predictions.filter(function (item) {
          return item.id == tgt;
        })[0];
        var x = JSON.parse(JSON.stringify(theValue));

        _this7.setState({
          targetState: 'closed'
        });

        var ppr;
        if (_this7.state.places[x.place_id]) ppr = _this7.state.places[x.place_id];else {
          ppr = (0, _fetch.default)("/resources/clients/place.php?place=".concat(encodeURIComponent(x.place_id))).then(function (d) {
            return d.json();
          });

          _this7.setState(function (state) {
            return {
              places: Object.assign({}, state.places, babelHelpers.defineProperty({}, x.place_id, ppr))
            };
          });
        }
        ppr.then(function (value) {
          _this7.setState({
            value: value.result.formatted_address,
            currentPlace: value
          });

          _this7.onChange(value);
        });
      });
    }
  }, {
    key: "selectPrediction",
    value: function selectPrediction(event) {
      var tgt = event.currentTarget.dataset.prediction;
      this.selectPredictionId(tgt);
    }
  }]);
  return GooglePlacesAutocompleteField;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (prediction) {};
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialValue", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialPlace", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "dark", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "placeholder", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "placeFilter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '(cities)';
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "disabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "inputChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "inputChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotFocus"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotRoot"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "bodyClicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "bodyClicked"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotInput", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotInput"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_renderError", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_renderError"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_renderPending", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_renderPending"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_renderSuccess", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_renderSuccess"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "dumpEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "dumpEvent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gmPlaceName", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gmPlaceName"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gmPlaceAdr", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gmPlaceAdr"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "keyDownEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "keyDownEvent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectPrediction", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectPrediction"), _class.prototype)), _class);
exports.default = GooglePlacesAutocompleteField;

function testField() {
  var x = document.createElement('div');
  x.style.cssText = "position: absolute; top: 100px; left: 100px; width: calc(var(--scalable-unit) * 500 / 16);";
  document.body.appendChild(x);
  ReactDOM.render(_react.default.createElement(GooglePlacesAutocompleteField, null), x);
}